export default defineAppConfig({
    //
})
